import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/core/services/auth.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { MeetingService } from 'src/app/core/services/meeting.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';

@Component({
  selector: 'app-cancel-job-match-meeting',
  templateUrl: './cancel-job-match-meeting.component.html',
  styleUrls: ['./cancel-job-match-meeting.component.css']
})
export class CancelJobMatchMeetingComponent implements OnInit {
  @ViewChild('cancelForm') cancelForm!: NgForm;

  @Input() jobMatchObject: any;
  @Input() isSharedRequisition: any;
  @Input() itemType: any;
  @Input() jobMatchId: any;
  @Input() sourceScreen: any;
  @Input() formalizeActivityPayload: any;
  @Output() saveCallback = new EventEmitter<any>();

  meetingsList: any[] = [];
  chosenMeeting: any;
  usersListLabel = '';
  itemDisplayLabel = '';

  cancellableMeetingsExistFlag = true;
  loadingFlag = false;
  showFormFlag = false;
  savingFlag = false;
  viewMode = false;
  copyNote = false;
  isExternalRequisition = false;
  isCorporateFlag = false;

  startDate = '';
  startTime = '';
  endDate = '';
  endTime = '';
  cancelLabel = 'Cancel';
  noCancellableMeetingsLabel = '';

  companyId = '';

  scheduleData: any = {
    emailAddress: '',
    firstName: '',
    lastName: '',
    role: '',
    department: '',
    note: '',
    externalNote: ''
  };

  constructor(
    private jobMatchService: JobMatchService,
    private authService: AuthService,
    private meetingService: MeetingService,
    private companyService: CompanyService,
    private alertsAndNotificationsService: AlertAndNotificationsService
  ) { }

  formatDate(date: any, timeZone?: string): string {
    return date ? new
      Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        timeZone: timeZone || undefined
      }) : '';
  }

  formatTime(date: any, timeZone?: string): string {
    return date ? new
      Date(date).toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: timeZone || undefined
      }) : '';
  }

  ngOnInit(): void {

    //variables
    this.scheduleData = {
      isCompany: true,
      jobMatchId: '',
      note: '',
      externalNote: '',
      emailAddress: '',
      firstName: '',
      lastName: '',
      role: '',
      department: '',
      company: '',
      startDateTime: '',
      endDateTime: ''
    };
    this.itemDisplayLabel = '';
    this.usersListLabel = '';
    this.cancelLabel = '';
    this.chosenMeeting = null;
    this.meetingsList = [];
    this.startDate = '';
    this.startTime = '';
    this.endDate = '';
    this.endTime = '';
    //flags
    this.savingFlag = false;
    this.showFormFlag = false;
    this.loadingFlag = false;
    this.cancellableMeetingsExistFlag = false;
    this.isCorporateFlag = this.companyService.isCorporateCompany();
    this.isExternalRequisition = !this.isCorporateFlag;
    const user = this.authService.getUserDetails();
    let companyId = '';
    if (this.jobMatchObject && this.jobMatchObject.jobMatchCompanyId) {
      companyId = this.jobMatchObject.jobMatchCompanyId;
    } else if (this.jobMatchObject && this.jobMatchObject.corporateCompanyId) {
      companyId = this.jobMatchObject.corporateCompanyId;
    } else if (this.jobMatchObject && this.jobMatchObject.clientOrBuId) {
      companyId = this.jobMatchObject.clientOrBuId;
    } else if (user && user.company && user.company.companyId) {
      companyId = user.company.companyId;
    }

    this.scheduleData.company = companyId;
    this.companyId = (user && user.company && user.company.companyId) || '';
    if (!this.scheduleData.company) {
      console.error('Company ID is missing - check jobMatchObject or authService');
      return;
    }

    switch (this.itemType) {
      case 'recruiterScreening':
        this.itemDisplayLabel = 'Recruiter Screening';
        this.usersListLabel = 'Select Recruiter Screening';
        this.cancelLabel = 'Cancel Recruiter Screening';
        this.noCancellableMeetingsLabel = "No 'Scheduled' Recruiter Screenings are available to cancel !";
        break;
      case 'phoneScreen':
        this.itemDisplayLabel = 'Phone Screen';
        this.usersListLabel = 'Select Phone Screen';
        this.cancelLabel = 'Cancel Phone Screen';
        this.noCancellableMeetingsLabel = "No 'Scheduled' Phone Screens are available to cancel !";
        break;
      case 'interview':
        this.itemDisplayLabel = 'Interview';
        this.usersListLabel = 'Select Interview';
        this.cancelLabel = 'Cancel Interview';
        this.noCancellableMeetingsLabel = "No 'Scheduled' Interviews are available to cancel !";
        break;
    }

    this.getScheduledItems();
  }

  getScheduledItems(): void {
    this.loadingFlag = true;
    if (this.itemType == 'recruiterScreening') {
      this.jobMatchService.getRecruiterScreeners(this.jobMatchId, this.companyId, null, false, (data: any) => {
        this.loadingFlag = false;
        this.meetingsList = this.getMeetingsList(data);
      }, (error: any) => {
        this.loadingFlag = false;
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    }
    else if (this.itemType == 'phoneScreen') {
      this.jobMatchService.getPhoneScreeners(this.jobMatchId, this.companyId, null, false, (data: any) => {
        this.loadingFlag = false;
        this.meetingsList = this.getMeetingsList(data);
      }, (error: any) => {
        this.loadingFlag = false;
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    } else {
      this.jobMatchService.getInterviewers(this.jobMatchId, this.companyId, null, false, (data: any) => {
        this.loadingFlag = false;
        this.meetingsList = this.getMeetingsList(data);
      }, (error: any) => {
        this.loadingFlag = false;
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    }
  }

  getMeetingsList(response: any[]): any[] {
    const meetingsList: any[] = [];
    const workflowStep = this.itemType === 'recruiterScreening' ? 'rs' : (this.itemType === 'phoneScreen' ? 'ps' : 'in');
    response.forEach((meetingDetails: any) => {
      const meeting: any = {};
      meeting.id = meetingDetails.meetingScheduleId;
      meeting.status = meetingDetails.status;
      meeting.meetingMode = meetingDetails.meetingMode;
      meeting.meetingUrl = this.meetingService.getMeetingUrl(meeting.id, workflowStep, meeting.meetingMode);
      meeting.createdByCompanyId = meetingDetails.company;
      meeting.isCreatedByClient = meeting.createdByCompanyId != null && meeting.createdByCompanyId !== this.companyId && !this.isCorporateFlag;
      const startDateTime = new Date(meetingDetails.meetingStartTime);
      const endDateTime = new Date(meetingDetails.meetingEndTime);

      switch (meeting.status) {
        case 'SCHEDULED':
          meeting.statusClass = 'fa fa-calendar meeting-icon-scheduled';
          meeting.statusLabel = 'Scheduled';
          meeting.editableFlag = true;
          this.cancellableMeetingsExistFlag = true;
          break;
        case 'OVERDUE':
          meeting.statusClass = 'fas fa-clock meeting-icon-overdue';
          meeting.statusLabel = 'Overdue';
          meeting.editableFlag = true;
          this.cancellableMeetingsExistFlag = true;
          break;
        case 'IN_PROGRESS':
          meeting.statusClass = 'fas fa-hourglass-half meeting-icon-in-progress';
          meeting.statusLabel = 'In Progress';
          meeting.editableFlag = false;
          break;
        case 'COMPLETED':
          meeting.statusClass = 'fa fa-check meeting-icon-completed';
          meeting.statusLabel = 'Completed';
          meeting.editableFlag = false;
          break;
        case 'CANCELLED':
          meeting.statusClass = 'fa fa-ban meeting-icon-cancelled';
          meeting.statusLabel = 'Canceled';
          meeting.editableFlag = false;
          break;
        default:
          meeting.statusClass = 'fa fa-question meeting-icon-in-progress';
          meeting.statusLabel = 'Status Unknown';
          meeting.editableFlag = false;
      }

      switch (meeting.meetingMode) {
        case 'VIDEO':
          meeting.meetingModeClass = 'fas fa-video';
          break;
        case 'AUDIO':
          meeting.meetingModeClass = 'fas fa-microphone';
          break;
        case 'PHONE':
          meeting.meetingModeClass = 'fas fa-phone';
          break;
        case 'FACE_TO_FACE':
          meeting.meetingModeClass = 'fas fa-user-friends';
          break;
        default:
          meeting.meetingModeClass = 'd-none';
          break;
      }

      meeting.scheduledTime = startDateTime.toLocaleString() + ' - ' + endDateTime.toLocaleTimeString();
      meeting.userList = [];
      meeting.userNamesLabel = '';
      (meetingDetails.participants || []).forEach((meetingUser: any) => {
        const user: any = {};
        user.userId = meetingUser.id;
        user.userName = meetingUser.firstName;
        user.isPoc = meetingUser.isPoc;
        if (meetingUser.lastName != null) {
          user.userName += ' ' + meetingUser.lastName;
        }
        meeting.userList.push(user);
        if (this.isSharedRequisition && !this.isCorporateFlag) {
          if (user.isPoc) {
            meeting.userNamesLabel = (meeting.userNamesLabel === '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
          }
        } else {
          meeting.userNamesLabel = (meeting.userNamesLabel === '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
        }
      });
      meetingsList.push(meeting);
    });
    return meetingsList;
  }

  meetingChanged(): void {
    if (!this.chosenMeeting) return;
    this.showFormFlag = false;
    this.loadingFlag = true;
    this.viewMode = this.chosenMeeting.isCreatedByClient;
    this.jobMatchService.getMeetingDetails(this.chosenMeeting.id, (data: any) => {
      const participant = data.participants[0];
      this.scheduleData.firstName = participant.firstName;
      this.scheduleData.lastName = participant.lastName;
      this.scheduleData.emailAddress = participant.email;
      this.scheduleData.role = participant.role;
      this.scheduleData.department = participant.department || '-';
      this.scheduleData.note = data.note;
      this.scheduleData.externalNote = data.externalNote;
      const start = data.startTime || data.startDateTime;
      const end = data.endTime || data.endDateTime;
      this.startDate = this.formatDate(start, data.timeZoneName);
      this.startTime = this.formatTime(start, data.timeZoneName);
      this.endDate = this.formatDate(end, data.timeZoneName);
      this.endTime = this.formatTime(end, data.timeZoneName);
      this.loadingFlag = false;
      this.showFormFlag = true;
    }, (error: any) => {
      this.loadingFlag = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  cancelMeeting(): void {
    if (this.cancelForm.invalid) return;
    this.savingFlag = true;
    const meetingObject = {
      companyId: this.scheduleData.company,
      note: this.scheduleData.note,
      externalNote: this.scheduleData.externalNote
    };
    this.jobMatchService.cancelMeeting(this.chosenMeeting.id, meetingObject, () => {
      this.savingFlag = false;
      this.chosenMeeting = null;
      this.showFormFlag = false;
      this.saveCallback.emit();
    }, (error: any) => {
      this.savingFlag = false;
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  onInternalNoteChanged(): void {
    if (this.copyNote) {
      this.scheduleData.externalNote = this.scheduleData.note;
    }
  }

  onExternalNoteChange(event: any): void {
    if (event) {
      this.scheduleData.externalNote = event.externalNote;
    }
  }

  onCopyNoteChange(event: any): void {
    if (event) {
      this.copyNote = event.copyNote;
    }
  }

  receiveFormalizedComment(event: any): void {
    this.scheduleData.note = event;
    this.onInternalNoteChanged();
  }

  onVoiceTranscript(transcript: any): void {
    if (this.scheduleData.note) {
      this.scheduleData.note += ' ' + transcript;
    } else {
      this.scheduleData.note = transcript;
    }
    this.onInternalNoteChanged();
  }

}
